"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VerticalSeparationFieldView = exports.Styles = exports.CSS = void 0;
exports.canUpdate = canUpdate;
const core_shared_1 = require("@ikegps/core-shared");
const field_action_button_1 = require("../../../components/button/field.action.button");
const vertical_separation_input_state_1 = require("../../../components/input/vertical.separation.input.state");
const notification_service_1 = require("../../../components/notification.toast/notification.service");
const theme_1 = require("../../../components/theme");
const i18n_1 = require("../../../i18n");
const mithril_1 = require("../../../mithril");
const services_1 = require("../../../services");
const page_state_1 = require("../../../state/page.state");
const capture_thumbnail_1 = require("../../capture.thumbnail/capture.thumbnail");
exports.CSS = {
    container: 'c-PMLink',
    isHovered: 'c-PMLink--hovered',
    isLinked: 'c-PMLink--linked',
    height: 'c-PMLink__Height',
};
exports.Styles = {
    [exports.CSS.container]: {
        display: 'flex',
        'justify-content': 'space-between',
    },
    [exports.CSS.isHovered]: {
        'font-weight': 'bold',
    },
    [exports.CSS.isLinked]: {
        cursor: 'pointer',
    },
    [exports.CSS.height]: {
        width: '100%',
    },
};
(0, theme_1.addStyles)(exports.Styles);
function selectDrawable(draw, drawableId) {
    draw.state.setSelected(drawableId, null);
    return false;
}
function hoverDrawable(captureId, drawableId, hovered) {
    const draw = page_state_1.CurrentState.CollectionEdit.getIkeDraw(captureId);
    if (draw == null) {
        return;
    }
    if (hovered) {
        draw.state.setHovered(drawableId);
    }
    else if (draw.state.hoverId === drawableId) {
        draw.state.setHovered(null);
    }
}
function canUpdate() {
    return true;
}
exports.VerticalSeparationFieldView = {
    viewInline(field) {
        return core_shared_1.IkeUnit.display(field.value, services_1.Services.UserSettings.units === 'meters' ? core_shared_1.IkeUnit.CENTIMETER : core_shared_1.IkeUnit.INCH, null, null, 0);
    },
    hasDetail(field) {
        return field.getCaptures().length > 0;
    },
    viewDetail(field) {
        if (!exports.VerticalSeparationFieldView.hasDetail(field)) {
            return null;
        }
        const capture = field.getCaptures()[0];
        const title = services_1.Services.DateTime.formatDateTime(capture.collectedAt.iso);
        return capture_thumbnail_1.CaptureThumbnail.view(field.collection, capture, { crosshair: true, title });
    },
    viewEdit(field, ctrl) {
        if (!canUpdate()) {
            return exports.VerticalSeparationFieldView.viewInline(field, ctrl);
        }
        const currentDraw = page_state_1.CurrentState.CollectionEdit.currentDraw;
        const canLinkTo = currentDraw != null && currentDraw.drawState.hasUserMeasurements();
        let inputState = ctrl.changeState.getState(field.id);
        if (inputState == null) {
            inputState = new vertical_separation_input_state_1.VerticalSeparationInputState(field.schema.displayName);
            ctrl.changeState.addState(field.id, inputState);
        }
        inputState.validateInput(field.stateValue);
        if (field.hasValue()) {
            let className = exports.CSS.container;
            const heightInline = exports.VerticalSeparationFieldView.viewInline(field, ctrl);
            if (currentDraw != null) {
                const stateValue = field.stateValue;
                const drawableTopId = field.stateValue.drawableTop;
                const drawableBottomId = field.stateValue.drawableBottom;
                // If the current field is hovered
                if (currentDraw.state.hoverId === drawableTopId || currentDraw.state.hoverId === drawableBottomId) {
                    className = className + ' ' + exports.CSS.isHovered;
                }
                // If the current field is part of the currentDrawable allow it to select the drawable
                let onclick = null;
                if (stateValue.captureId === currentDraw.capture.objectId) {
                    className = className + ' ' + exports.CSS.isLinked;
                    onclick = () => selectDrawable(currentDraw, drawableTopId);
                }
                // Set the hoverId for the drawable
                const onmouseover = () => hoverDrawable(stateValue.captureId, drawableTopId, true);
                const onmouseout = () => hoverDrawable(stateValue.captureId, drawableTopId, false);
                return (0, mithril_1.m)('div', { className, onmouseover, onmouseout }, [
                    (0, mithril_1.m)('span', { className: exports.CSS.height, onclick }, heightInline),
                ]);
            }
            return (0, mithril_1.m)('div', { className }, heightInline);
        }
        if (!canLinkTo) {
            return this.viewInline(field, ctrl);
        }
        const linkFieldIds = currentDraw.state.linkFieldIds;
        if (linkFieldIds.indexOf(field.id) !== -1) {
            return field_action_button_1.FieldActionButton.viewLinkVerticalSeparation({
                linking: true,
                onclick: () => currentDraw.state.setTool(null),
            });
        }
        // No fields are being linked show the link start behavior
        return field_action_button_1.FieldActionButton.viewLinkVerticalSeparation({
            joinable: ctrl.getJoin(field) != null,
            hasTop: field.hasDrawableTop(),
            hasBottom: field.hasDrawableBottom(),
            hasError: inputState.hasError(),
            onclick: () => {
                page_state_1.CurrentState.cancelInteractions();
                const oppositeJoin = ctrl.getOppositeJoin(field);
                if (oppositeJoin != null) {
                    currentDraw.state.setLinkFields([field.id, oppositeJoin.field.id]);
                    notification_service_1.NotificationService.info({ key: i18n_1.T.PHOTOMEASURE_JOIN_START, attrs: oppositeJoin.getTitle() });
                    services_1.Services.Analytics.trackEvent(services_1.Services.Analytics.EventCategory.Mutate, 'measurement:join', ctrl.collection.revision, 1);
                }
                else {
                    currentDraw.state.setLinkFields([field.id]);
                }
            },
        });
    },
    hasClear(field) {
        return field.hasValue() || field.hasDrawableTop();
    },
};
//# sourceMappingURL=vertical.separation.field.view.js.map